import { createAction } from '@reduxjs/toolkit'
import { UndoRedoState } from '../reducers/history'

export const setHistory = createAction<UndoRedoState>('history/setHistory')
export const undo = createAction('history/undo')
export const redo = createAction('history/redo')
export const updateHistory = createAction<UndoRedoState>(
  'history/updateHistory',
)
export const resetUpdatedTime = createAction('history/resetUpdatedTime')
